module.exports = __webpack_public_path__ + "static/media/async.d0897b56.svg";